import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/storybook-components/dist/Box'
import { Button } from '@node-space/storybook-components/dist/Button'
import { Approval } from 'constants/General'

interface ApprovalHeaderButtonsProps {
  canManageApprovers?: boolean
  canManageApprovalTransactions: boolean
  handleManageApprovers: () => void
  handleApprovalDecision: (approvalDecision: string) => void
  hasCheckedPendingTransactions?: boolean
}

const ApprovalHeaderButtons = ({
  canManageApprovalTransactions,
  handleManageApprovers,
  handleApprovalDecision,
  hasCheckedPendingTransactions,
}: ApprovalHeaderButtonsProps) => {
  const { t } = useTranslation()

  return (
    <Box flex className="sm:p-0">
      <Box width="full" className="sm:w-auto">
        <Button secondary onClick={handleManageApprovers}>
          {t('approvals.manageApprovers')}
        </Button>
      </Box>

      {canManageApprovalTransactions && (
        <>
          <Box width="full" className="ml-3 sm:w-auto">
            <Button
              disabled={!hasCheckedPendingTransactions}
              onClick={() => handleApprovalDecision(Approval.DECISION.APPROVE)}
            >
              {t('approvals.approve')}
            </Button>
          </Box>
          <Box width="full" className="ml-3 sm:w-auto">
            <Button
              disabled={!hasCheckedPendingTransactions}
              onClick={() => handleApprovalDecision(Approval.DECISION.REJECT)}
            >
              {t('approvals.reject')}
            </Button>
          </Box>
        </>
      )}
    </Box>
  )
}

export default React.memo(ApprovalHeaderButtons)
